export const pagesDevicesRuleAndPolicyEn = {
  backToList: 'Back to list',
  btn: {
    addRule: 'Add Rule',
    addRuleGroup: 'Add Rule Group',
    changeOrder: 'Change Order'
  },
  cancel: 'Cancel',
  createRule: 'Create Rule',
  delete: 'Delete',
  deleteRuleBody: 'This rule will be permanently deleted.',
  deleteRuleBodyInclusions: '{{count}} exception assignment(s) linked to this rule will also be deleted.',
  deleteRuleGroupBody: 'This rule group will be permanently deleted.',
  deleteRuleGroupDisabled: 'Remove all member rules before deleting the group.',
  deleteRuleGroupTitle: 'Delete {{name}}?',
  deleteRuleTitle: 'Delete {{name}}?',
  description: 'Set rules for assigning devices to people',
  detailTitle: 'Assignment Rule: {{name}}',
  dialog: {
    createRuleGroupTitle: 'Add Rule Group',
    editRuleGroupTitle: 'Edit Rule Group'
  },
  edit: 'Edit',
  editRule: 'Edit Assignment Rule',
  filter: {
    all: 'All',
    deviceGroup: 'Device Group',
    memberGroup: 'People Group',
    moveDown: 'Move Down',
    moveUp: 'Move Up',
    resultCount: '{{count}} items'
  },
  form: {
    description: 'Description',
    descriptionPlaceholder: 'e.g. Standard laptop assignment',
    deviceGroupNoResults: 'No matching device groups found',
    deviceGroupPlaceholder: 'Select a device group...',
    deviceGroupSearchPlaceholder: 'Search device groups...',
    groupName: 'Rule group name',
    independent: 'No group',
    manageDeviceGroups: 'Settings',
    name: 'Rule Name',
    namePlaceholder: 'e.g. Standard laptop',
    optional: '(optional)',
    orderInGroup: 'Order in Group',
    orderInGroupOptionalHint: 'Leave blank to add at the end',
    peopleGroups: 'People Groups',
    peopleGroupsNoResults: 'No matching people groups found',
    peopleGroupsPlaceholder: 'Select a people group...',
    peopleGroupsSearchPlaceholder: 'Search people groups...',
    preview: {
      error: 'Failed to load preview. Check your selections.',
      tabs: {
        devices: 'Device',
        persons: 'People'
      },
      title: 'Target'
    },
    ruleGroup: 'Rule Group',
    ruleGroupHelp: 'Link a rule group to make this rule mutually exclusive with others',
    ruleGroupsLoadError: 'Failed to load rule groups. Rule group selection is unavailable.',
    sections: {
      basic: {
        help: 'Identification for the rule. Use a name and description that explain its purpose to operators.',
        title: 'Basic Information'
      },
      deviceGroup: {
        help: 'Specify which devices should be assigned to the target members.',
        title: 'Device Group'
      },
      peopleGroups: {
        help: 'Specify the members this rule applies to.',
        title: 'People Groups'
      }
    },
    validation: {
      deviceGroupRequired: 'Select a device group',
      nameRequired: 'Enter a rule name',
      orderInGroupInvalid: 'Order in group must be a positive integer',
      peopleGroupsRequired: 'Select at least one people group'
    }
  },
  inclusions: {
    addButton: 'Add',
    candidatesEmpty: 'No alert candidates available',
    candidatesLoadError: 'Failed to load alert candidates',
    candidatesLoading: 'Loading alert candidates…',
    columns: {
      actions: 'Action',
      assignmentRule: 'Rule',
      device: 'Device',
      member: 'Person',
      reason: 'Reason'
    },
    delete: 'Delete',
    deleteConfirmBody: 'This entry will be permanently deleted',
    deleteConfirmTitle: 'Remove {{member}} from {{list}}?',
    dialog: {
      allowlistHint: 'Hidden from Unknown assignment alerts',
      assignmentRule: 'Rule',
      assignmentRulePlaceholder: 'Select a rule',
      cancel: 'Cancel',
      createTitle: 'Add to {{list}}',
      device: 'Device',
      devicePlaceholder: 'Select a device',
      editTitle: 'Edit {{list}} entry',
      exclusionHint: 'Hidden from To be assigned alerts',
      person: 'Person',
      personPlaceholder: 'Select a person',
      reason: 'Reason',
      reasonPlaceholder: 'Enter a reason…',
      save: 'Save',
      validation: {
        assignmentRuleRequired: 'Select a target rule',
        deviceRequired: 'Select a device',
        personRequired: 'Select a member',
        reasonRequired: 'Enter a reason'
      }
    },
    edit: 'Edit',
    help: 'People added here are excluded from this rule',
    loadError: 'Failed to load exception assignments.',
    systemTitle: 'Overrides',
    tabs: {
      allowlist: 'Allowlist',
      exclusion: 'Exclusion list'
    },
    title: 'Overrides: Exclusion list'
  },
  listTitle: 'Assignment Rules',
  loadError: 'Failed to load rules.',
  openMenu: 'Open Menu',
  pageTitle: 'Rules & Policy',
  reorderSaveError: 'Failed to save rule order. The list has been refreshed.',
  reorderSavePartialError: 'Failed to save order for {{failed}} rule group(s). Saved changes are applied. The list has been refreshed.',
  save: 'Save',
  searchPlaceholder: 'Search...',
  sideTab: {
    assignment: 'Assignment',
    assignmentRules: 'Assignment Rules',
    closeSideTab: 'Close Sidebar',
    openSideTab: 'Open Sidebar'
  },
  systemExceptionsName: 'Overrides',
  table: {
    deviceCount: 'Devices',
    deviceCountValue: '{{count}}',
    deviceGroup: 'Device Group',
    inclusionCount: '{{count}} items',
    memberGroup: 'People Group',
    noMembers: '– No Members –',
    order: 'Order',
    rule: 'Rule',
    rulesInGroup: '{{count}} rules',
    targetPersonCount: 'People',
    toBeAssignedCount: 'To be assigned',
    unnamedRule: '(Unnamed)'
  },
  wizard: {
    completeDialog: {
      createMessage: 'Rule created successfully.',
      detailLink: 'View rule',
      listLink: 'Back to rules list'
    },
    confirm: {
      description: 'Description',
      deviceGroup: 'Device Group',
      name: 'Rule Name',
      orderInGroup: 'Order in Group',
      peopleGroups: 'People Groups',
      ruleGroup: 'Rule Group',
      tailOrder: 'Add at end (position {{order}})'
    },
    navigation: {
      basic: 'Basic Information',
      confirm: 'Confirm',
      target: 'Assignment Targets',
      titleCreate: 'Create Device Assignment Rule'
    },
    stepTitle: {
      basic: '1. Basic Information',
      confirm: '3. Confirm',
      target: '2. Assignment Targets'
    },
    submitError: 'Some entries are invalid. Please review your inputs.'
  }
};